import { render, staticRenderFns } from "./indetity.vue?vue&type=template&id=416f163b&scoped=true&"
import script from "./indetity.vue?vue&type=script&lang=js&"
export * from "./indetity.vue?vue&type=script&lang=js&"
import style0 from "./indetity.vue?vue&type=style&index=0&id=416f163b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f163b",
  null
  
)

export default component.exports